<template>
  <div v-if="reportsOfSickness.length > 0 && uwvDecisions.length > 0">
    <bordered-container title='UWV Beslissingen'>
      <div class='hf'>
        <table class='summary-table no-side-border last-no-border'>
          <th align="center">{{ 'uwv-decision.fields.decision-type' | translate }}</th>
          <th align="center">{{ 'uwv-decision.fields.decision-date' | translate }}</th>
          <tr v-for="(uwvDecision, i) in uwvDecisions" :key="'uwv-decision-' + i"
            @click="navigateToReportOfSickness(uwvDecision)" style='cursor: pointer;'>
            <td><p class='value'>{{ 'uwv-decision.types.' + uwvDecision.decisionType | translate }}</p></td>
            <td><p class='value'>{{ formatDate(uwvDecision.decisionDate)}}</p></td>
          </tr>
        </table>
      </div>
    </bordered-container>
  </div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import AppNavigation from '@/views/constants/app-navigation';
import ReportsOfSickness from '@/views/constants/reports-of-sickness';

import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';

export default {
  name: 'EmployeeUwvDecisions',
  components: {
    BorderedContainer
  },
  props: {
    employee: Object
  },

  computed: {
    reportsOfSickness () {
      let result = this.$store.getters.reportsOfSickness[this.employee.id];
      if (result != null) return result;
      return [];
    },

    uwvDecisions () {
      let result = [];
      this.reportsOfSickness.forEach(r => {
        if (r.uwvDecisions.length > 0) {
          r.uwvDecisions.forEach(u => {
            result.push(u);
          });
        }
      });
      return result;
    }
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),

    navigateToReportOfSickness (uwvDecision) {
      const _reportOfSickness = this.reportsOfSickness.find(r => r.id === uwvDecision.reportOfSicknessId);

      this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.ReportsOfSickness)
        .then(this.$store.dispatch(ReportsOfSickness.Actions.Tabs.OPEN_DETAILS, {
          reportOfSickness: _reportOfSickness,
          employee: this.employee
        })
        );
    }
  }
};
</script>

<style lang='scss' scoped>
  .summary-table {
    th {
      font-size: 0.9em;
    }
  }
</style>
